export const NAME = 'document-catalog';
